import "./Background.css";

function Background() {
  return (
    <div className="background">
      <div className="darken"></div>
      <div className="grid">
        {Array(30)
          .fill(null)
          .map((_, index) => (
            <div
              className="grid-column"
              key={index}
              style={{
                transform: `translateY(${20 * index}px ) `,
              }}
            >
              {Array(20)
                .fill(null)
                .map((_, innerIndex) => (
                  <div className="grid-item" key={innerIndex}></div>
                ))}
            </div>
          ))}
      </div>
    </div>
  );
}

export default Background;
